import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-quantity',
    templateUrl: './quantity.component.html',
    styleUrls: ['./quantity.component.scss'],
    standalone: false
})
export class QuantityComponent {
  quantity: number = 1;

  @Output() quantityChange = new EventEmitter<number>();

  increase() {
    this.quantity++;
    this.quantityChange.emit(this.quantity);
  }

  decrease() {
    if (this.quantity > 1) {
      this.quantity--;
      this.quantityChange.emit(this.quantity);
    }
  }
}
